"use client";

import { Shield, Eye, Lock } from "lucide-react";
import { motion } from "framer-motion";

const blocks = [
  {
    icon: Shield,
    title: "Runs where you trust it",
    description: "We deploy on hardware or VPS you own and control. No opaque multi-tenant SaaS; Clawbiz runs on your side of the wall.",
  },
  {
    icon: Eye,
    title: "Scopes you can live with",
    description: "Calibrated file and shell access: only the directories and commands you're comfortable with. Channel allow-lists, access control, and environment hardening.",
  },
  {
    icon: Lock,
    title: "No surprise services",
    description: "Clear view of which models, APIs, and skills are active. You keep the keys: API tokens, gateway config, model choices.",
  },
];

export const SecuritySection = () => {
  return (
    <section className="section-spacing overflow-hidden relative">

      <div className="section-container relative z-10">
        <div className="max-w-5xl mx-auto space-y-12">
          <motion.div
            className="text-center space-y-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="text-3xl md:text-5xl font-display font-medium leading-tight">
              Your machine. Your data. <span className="gradient-text">Your rules.</span>
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-6">
            {blocks.map((block, index) => {
              const Icon = block.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="relative group"
                >
                  <div className="absolute -inset-[1px] rounded-2xl bg-gradient-to-b from-[hsl(var(--coral-bright)/0.1)] to-[hsl(var(--cyan-bright)/0.1)] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  
                  <div className="relative glass-card rounded-2xl p-6 space-y-4 hover:bg-white/[0.04] transition-all duration-300">
                    <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[hsl(var(--coral-bright)/0.15)] to-[hsl(var(--cyan-bright)/0.1)] flex items-center justify-center">
                      <Icon className="w-5 h-5 text-primary" />
                    </div>
                    <h3 className="text-lg font-display font-medium">{block.title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{block.description}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
